import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=90220e66&scoped=true&"
import script from "./charge.vue?vue&type=script&lang=js&"
export * from "./charge.vue?vue&type=script&lang=js&"
import style0 from "./charge.vue?vue&type=style&index=0&id=90220e66&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90220e66",
  null
  
)

export default component.exports